// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-misused-promises */

import * as types from "./actionTypes";
import * as quantifiedRegionsApi from "../../apis/quantifiedRegionApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

/*
 *  Action Creators
 *
 */

export function createFlightsQuantifiedRegionsSuccess() {
	return { type: types.QUANTIFIED_REGIONS_CREATE_FLIGHTS_QUANTIFIED_REGIONS_SUCCESS };
}

export function updateFlightsQuantifiedRegionsSuccess() {
	return { type: types.QUANTIFIED_REGIONS_UPDATE_FLIGHTS_QUANTIFIED_REGIONS_SUCCESS };
}

export function checkIfFlightsQuantifiedRegionsExistSuccess() {
	return { type: types.QUANTIFIED_REGIONS_CHECK_IF_FLIGHTS_QUANTIFIED_REGIONS_EXIST_SUCCESS };
}

/*
 *  Thunks
 *
 */

export function createFlightsQuantifiedRegions(plotData, accessToken, fieldQuantifiedRegionIds) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return quantifiedRegionsApi
				.createFlightsQuantifiedRegions(plotData, accessToken, fieldQuantifiedRegionIds)
				.then((result) => {
					if (result.statusCode !== 200) {
						dispatch(apiCallError(result));
						reject(result);
					}
					dispatch(createFlightsQuantifiedRegionsSuccess());
					resolve(result);
				})
				.catch((error) => {
					dispatch(apiCallError(error));
					reject(error);
				});
		});
	};
}

export function updateFlightsQuantifiedRegions(plotData, accessToken) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return quantifiedRegionsApi
				.updateFlightsQuantifiedRegions(plotData, accessToken)
				.then((result) => {
					if (result.statusCode !== 200) {
						dispatch(apiCallError(result));
						reject(result);
					}
					dispatch(updateFlightsQuantifiedRegionsSuccess());
					resolve(result);
				})
				.catch((error) => {
					dispatch(apiCallError(error));
					reject(error);
				});
		});
	};
}

export function checkIfFlightsQuantifiedRegionsExist(flightId, clientId, accessToken) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return quantifiedRegionsApi
				.checkIfFlightsQuantifiedRegionsExist(flightId, clientId, accessToken)
				.then((res) => {
					if (res.statusCode !== 200) {
						dispatch(apiCallError(res));
						reject(res);
					}
					dispatch(checkIfFlightsQuantifiedRegionsExistSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError(error));
					reject(error);
				});
		});
	};
}
